/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CronJobMetadata
 */
export interface CronJobMetadata {
    /**
     * 
     * @type {string}
     * @memberof CronJobMetadata
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CronJobMetadata
     */
    schedule?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CronJobMetadata
     */
    perTenant?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CronJobMetadata
     */
    timezone?: string;
    /**
     * 
     * @type {number}
     * @memberof CronJobMetadata
     */
    maxGapSeconds?: number;
}

/**
 * Check if a given object implements the CronJobMetadata interface.
 */
export function instanceOfCronJobMetadata(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CronJobMetadataFromJSON(json: any): CronJobMetadata {
    return CronJobMetadataFromJSONTyped(json, false);
}

export function CronJobMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CronJobMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'schedule': !exists(json, 'schedule') ? undefined : json['schedule'],
        'perTenant': !exists(json, 'perTenant') ? undefined : json['perTenant'],
        'timezone': !exists(json, 'timezone') ? undefined : json['timezone'],
        'maxGapSeconds': !exists(json, 'maxGapSeconds') ? undefined : json['maxGapSeconds'],
    };
}

export function CronJobMetadataToJSON(value?: CronJobMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'schedule': value.schedule,
        'perTenant': value.perTenant,
        'timezone': value.timezone,
        'maxGapSeconds': value.maxGapSeconds,
    };
}

